// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelService extends React.Component<Props> {
  get appPromotionData() {
    return [
      {
        id: "service-directory",
        label: this.props.t("SERVICE_DIRECTORY"),
        details: this.props.t("SERVICE_DIRECTORY_DESCRIPTION"),
      },
      {
        id: "absence-support",
        label: this.props.t("ABSENCE_SUPPORT"),
        details: this.props.t("ABSENCE_SUPPORT_DESCRIPTION"),
      },
      {
        id: "user-reviews",
        label: this.props.t("USER_REVIEWS"),
        details: this.props.t("USER_REVIEWS_DESCRIPTION"),
      },
    ];
  }

  get servicesData() {
    return [
      {
        id: "provider-name",
        label: this.props.t("PROVIDER_NAME"),
        details: this.props.t("PROVIDED_NAME_DESCRIPTION"),
      },
      {
        id: "service-types",
        label: this.props.t("SERVICE_TYPES"),
        details: this.props.t("SERVICE_TYPES_DESCRIPTION"),
      },
      {
        id: "about",
        label: this.props.t("ABOUT_SERVICE"),
        details: this.props.t("SERVICE_ABOUT_DESCRIPTION"),
      },
      {
        id: "how-to-access",
        label: this.props.t("SERVICE_HOW_TO_ACCESS"),
        details: this.props.t("SERVICE_HOW_TO_ACCESS_DESCRIPTION"),
      },
      {
        id: "website",
        label: this.props.t("WEBSITE"),
        details: this.props.t("WEBSITE_DESCRIPTION"),
      },
      {
        id: "phone-number",
        label: this.props.t("PHONE_NUMBER"),
        details: this.props.t("PHONE_NUMBER_DESCRIPTION"),
      },
      {
        id: "annual-spend",
        label: this.props.t("ANNUAL_SPEND"),
        details: this.props.t("ANNUAL_SPEND_DESCRIPTION"),
      },
      {
        id: "user-name",
        label: this.props.t("USER_NAME_OPTIONAL"),
        details: this.props.t("USER_NAME_OPTIONAL_DESCRIPTION"),
      },
      {
        id: "password",
        label: this.props.t("PASSWORD_OPTIONAL"),
        details: this.props.t("PASSWORD_OPTIONAL_DESCRIPTION"),
      },
      {
        id: "hierarchy-area",
        label: this.props.t("HIERARCHY_AREA"),
        details: this.props.t("HIERARCHY_AREA_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("SERVICE_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.SERVICE_INSTRUCTIONS}
            title={this.props.t("SERVICE_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("APP_PROMOTION")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.appPromotionData} />
        <h6 className="font-weight-bold">{this.props.t("SERVICES")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.servicesData} />
      </div>
    );
  }
}

export default localize()(HelpPanelService);
